import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ZendeskArticleDetails from '../../../components/tools/zendesk/ZendeskArticleDetails/ZendeskArticleDetails';
import * as ZendeskActions from '../../../actions/tools/ZendeskActions';

function mapStateToProps(state) {
  return {
    zendesk: Object.assign({}, state.tools && state.tools.zendesk),
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(Object.assign({}, ZendeskActions), dispatch);
};

const ZendeskArticleDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(ZendeskArticleDetails);

export default ZendeskArticleDetailsContainer;
